<template>
    <div class="Modal__dialog" @mousedown.stop>
        <button @click="close" class="Modal__close" type="button" aria-label="Fermer">
            <i class="fas fa-times"></i>
        </button>
        <slot/>
    </div>
</template>

<script>
    import ModalBus from "../../../eventBus";

    export default {
        props: {
            isOpen: Boolean
        },
        methods: {
            close: function () {
                ModalBus.$emit('close');
                this.$emit('close');
            }
        }
    }
</script>
